import React, {useState} from 'react';
import useBidmiiProTier from '../../../common/useBidmiiProTier';
import SecondaryButton from '../../../common/StyledComponents/SecondaryButton';
import PrimaryButton from '../../../common/StyledComponents/PrimaryButton';
import {useHistory} from 'react-router-dom';
import SharingList from '../../../common/SharingList';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import useScreenWidth from '../../../common/useScreenWidth';
import {useRecoilValue} from 'recoil';
import {userState} from '../../../recoil/user/userAtom';
import {ShareOutlined} from '@mui/icons-material';
import {aboutReferralsDialogOpenState} from '../../../recoil/dialogs/DialogsRecoil';
import {theme} from '../../../Theme';
import BidmiiCheckbox from '../../../common/StyledComponents/BidmiiCheckbox';
import StandardDialog from '../../../common/StyledComponents/StandardDialog';
import {setFirestoreDocument} from '../../../util/UserUtils';

export default function AboutReferralsDialog(props: $TSFixMe) {
  const history = useHistory();
  const width = useScreenWidth();
  const proTier = useBidmiiProTier();
  const user = useRecoilValue(userState);
  const aboutReferralsOpen = useRecoilValue(aboutReferralsDialogOpenState);

  const [anchorEl, setAnchorEl] = useState(null);
  const [dontAskAgain, setDontAskAgain] = useState(false);

  const getReferralSteps = () => {
    const referralSteps = [
      {
        title: 'Share your code',
        body: 'Share your code through social media, email, or in person. Contractors that use your code to sign up for Bidmii Pro will get 2 months free!',
      },
      {
        title: 'Get free months',
        body: 'Every time a contractor signs up for Bidmii Pro using your referral code, you’ll get 1 month free, applied directly your subscription!',
      },
    ];
    if (proTier === 0) {
      referralSteps.unshift({
        title: 'Upgrade to Bidmii Pro',
        body: 'As soon as you finish your Pro account setup, you’ll receive a special referral code.',
      });
    }
    return referralSteps;
  };

  const handleClose = async () => {
    if (dontAskAgain) {
      await setFirestoreDocument(user, {aboutReferralsDialogShown: true});
    } else {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
      sessionStorage.setItem('aboutReferralsDialogShown', 1);
    }
    props.handleClose();
  };

  const handleOnClickShare = (event: $TSFixMe) => {
    event.preventDefault();
    event.stopPropagation();
    if (width > 600 || !('share' in navigator)) {
      setAnchorEl(event.currentTarget);
    } else {
      try {
        navigator.share({
          title:
            'Get 2 free months when you sign up for Bidmii Pro using this link!',
          url: `${window.location.origin}/bidmii-pro/checkout?code=${user.code}`,
        });
      } catch (e) {
        setAnchorEl(event.currentTarget);
      }
    }
  };

  return (
    <StandardDialog open={true} onClose={handleClose}>
      {aboutReferralsOpen === 3 ? (
        <>
          <Typography variant="body1" style={{fontSize: 22}}>
            Woops...looks like you are already subscribed.
          </Typography>
          <Typography
            variant="subtitle1"
            style={{lineHeight: 1.3, margin: '8px 0'}}>
            You can get free months of Bidmii Pro when you refer other
            contractors!
          </Typography>
        </>
      ) : (
        <Typography variant="body1" style={{fontSize: 22, marginBottom: 16}}>
          🎉 Get free months of Bidmii Pro when you refer other contractors!
        </Typography>
      )}
      {getReferralSteps().map((step, i) => (
        <Box mb={1} key={i}>
          <Typography variant="subtitle1">
            {i + 1}. {step.title}
          </Typography>
          <Typography
            variant="body2"
            style={{fontSize: 13, color: theme.palette.gray.dark}}>
            {step.body}
          </Typography>
        </Box>
      ))}

      {proTier > 0 && (
        <Box
          my={2}
          pt={3}
          pb={2}
          style={{
            backgroundColor: theme.palette.blue.light,
            borderRadius: 10,
          }}>
          <Grid container direction="column" alignItems="center">
            <Typography
              variant="h4"
              style={{color: theme.palette.blue.main, fontWeight: 'bold'}}>
              {user.code}
            </Typography>
            <Typography
              variant="subtitle2"
              style={{color: theme.palette.blue.main}}>
              REFERRAL CODE
            </Typography>
          </Grid>
        </Box>
      )}

      {aboutReferralsOpen === 2 && (
        <Box mb={-2}>
          <BidmiiCheckbox
            checked={dontAskAgain}
            onChange={(e: any) => setDontAskAgain(e.target.checked)}
            label="Don't ask me again"
          />
        </Box>
      )}

      <Grid
        container
        justifyContent="space-between"
        style={{marginTop: 24, marginBottom: -16}}>
        <SecondaryButton onClick={handleClose}>CLOSE</SecondaryButton>
        {proTier > 0 ? (
          <>
            <Popover
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}>
              <SharingList
                linkedIn
                bidmiiPro
                url={`${window.location.origin}/bidmii-pro/checkout?code=${user.code}`}
                quote="Get 2 free months when you sign up for Bidmii Pro using this link!"
              />
            </Popover>
            <PrimaryButton
              color={theme.palette.blue.main}
              onClick={handleOnClickShare}>
              <ShareOutlined fontSize="small" style={{marginRight: 4}} /> SHARE
              CODE
            </PrimaryButton>
          </>
        ) : (
          <PrimaryButton
            color={theme.palette.blue.main}
            onClick={() => {
              handleClose();
              history.push('/bidmii-pro/checkout');
            }}>
            GET STARTED
          </PrimaryButton>
        )}
      </Grid>
    </StandardDialog>
  );
}
